import { IconButton } from "@material-ui/core";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { Button, Image, Modal } from "react-bootstrap";
import Timer from "react-compound-timer";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Device } from "twilio-client";
import { get_twilio_calling } from "../../store/actions/dashboardAction/addingAction";
import isEmpty from "../../store/validation/is-Empty";
import { PopupActionButton } from "./buttonReusableComponent/ButtonReusableComponent";
import Alert from "react-s-alert";

export class TwilioCalling extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      open: false,
      country_code: null,
      mobile_number: null,
      user_name: null,
      onPhone: false,
      log: "Connecting...",
      muted: false,
      time: 0,
    };
  }

  componentDidMount() {
    // const token = this.props.auth.user.accessToken;
    // if (this.props.get_twilio_calling()) {
    //   this.props.get_twilio_calling(token, this.callback);
    // }
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (!isEmpty(nextProps.mobile_number) !== nextState.mobile_number) {
      return {
        mobile_number: nextProps.mobile_number,
      };
    }
    if (!isEmpty(nextProps.country_code) !== nextState.country_code) {
      return {
        country_code: nextProps.country_code,
      };
    }
    if (!isEmpty(nextProps.user_name) !== nextState.user_name) {
      return {
        user_name: nextProps.user_name,
      };
    }
    return null;
  }

  onOpenModal = () => {
    this.setState({ open: true });
  };

  onCloseModal = () => {
    this.setState({ open: false });
  };

  handleShow = () => {
    this.setState({ show: true });
  };

  handleClose = () => {
    this.setState({ show: false });
  };

  callback = (token) => {
    Device.setup(token, {
      closeProtection: true,
      enableIceRestart: true,
      edge: "roaming",
    });
    Device.on("ready", (ready) => {
      this.state.log = "Connected";
    });
    Device.on("error", (error) => {
      // Alert.error(`<h4>${error}</h4>`, {
      //   position: "top-right",
      //   effect: "bouncyflip",
      //   beep: true,
      //   html: true,
      //   timeout: 3000,
      //   offset: 35,
      // });
    });
    Device.on("connect", (connection) => {
      console.log("connected", connection);
      this.setState({
        onPhone: true,
        log: "Connecting...",
      });
    });
    Device.on("incoming", (check) => {
      console.log("incoming", check);
    });
    Device.on("cancel", (check) => {
      console.log("cancel", check);
    });
    Device.on("disconnect", (check) => {
      console.log("disconnect", check);
      this.setState({
        onPhone: false,
        log: "Call ended.",
      });
      this.handleClose();
    });
    Device.on("offline", (check) => {
      // console.log("offline", check);
      // Alert.error(`<h4>Please Refresh the page</h4>`, {
      //   position: "top-right",
      //   effect: "bouncyflip",
      //   beep: true,
      //   html: true,
      //   timeout: 3000,
      //   offset: 35,
      // });
      // window.location.reload();
    });
  };

  onCallConnect = (e) => {
    // this.setState({
    //   show: !this.state.show,
    //   open: false,
    // });
    const mobileNumber = this.state.country_code + this.state.mobile_number;
    let params = { number: mobileNumber };
    // if (isNaN(params.number)) {
    //   Alert.error(`<h4>Phone number not found</h4>`, {
    //     position: "top-right",
    //     effect: "bouncyflip",
    //     beep: true,
    //     html: true,
    //     timeout: 3000,
    //     offset: 35,
    //   });
    // } else {
    //   Alert.success(`<h4>Working......</h4>`, {
    //     position: "top-right",
    //     effect: "bouncyflip",
    //     beep: true,
    //     html: true,
    //     timeout: 3000,
    //     offset: 35,
    //   });
    // }
    Device.connect(params);
  };

  onCallDisconnect = (e) => {
    Device.disconnectAll();
    this.handleClose();
  };

  // Handle muting
  handleToggleMute = (e) => {
    var muted = !this.state.muted;
    this.setState({ muted: muted });
    // Device.activeConnection().mute(muted);
  };

  render() {
    const { open, show, muted } = this.state;
    return (
      <div>
        <Button
          variant="link"
          className="enIconBtn mr-3"
          onClick={this.onOpenModal}
        >
          <Image
            src={require("../../assets/images/UserManagement/phone.svg")}
            alt="Call"
            title="Calling Button"
            fluid
          />
        </Button>
        <Modal
          show={open}
          onHide={this.onCloseModal}
          centered
          size="sm"
          className="enCallModal"
          backdrop="static"
        >
          <div className="p-4">
            <div className="d-flex justify-content-between">
              <div className="f20_700_HelveticaNeue">
                Call {this.state?.user_name && this.state?.user_name}
              </div>
              <div className="cursor" onClick={this.onCloseModal}>
                <Image
                  src={require("../../assets/images/UserManagement/close.svg")}
                  alt="Call"
                  title="Calling Button"
                  fluid
                />
              </div>
            </div>
            <div className="f14-400 text-dark py-3">
              Do you want to call{" "}
              {this.state?.user_name && this.state?.user_name}
            </div>
            <div className="d-flex align-items-center py-3">
              <div className="mr-3">
                <PopupActionButton
                  buttonText="No"
                  buttonType="button"
                  buttonClass="noButton"
                  onClick={this.onCloseModal}
                />
              </div>
              <PopupActionButton
                buttonText="Yes"
                buttonType="button"
                buttonClass="yesButton"
                onClick={this.onCallConnect}
              />
            </div>
          </div>
        </Modal>
        <Modal
          show={show}
          onHide={this.handleClose}
          centered
          size="sm"
          className="enCallModal"
          backdrop="static"
        >
          <Modal.Header className="pb-0 border-0" closeButton></Modal.Header>
          <Modal.Body className="text-center pt-0 mt-3">
            <div className="f11-700 mb-4">
              {this.state?.user_name && this.state?.user_name}
            </div>
            <div className="f18-500 text-red">{this.state.log}</div>
            <div className="f20-400 mb-4 text-green">
              <Timer
                formatValue={(value) => `${value < 10 ? `0${value}` : value}`}
                lastUnit="h"
              >
                {() => (
                  <React.Fragment>
                    <Timer.Hours /> :
                    <Timer.Minutes /> :
                    <Timer.Seconds />
                  </React.Fragment>
                )}
              </Timer>
            </div>
            <div className="d-flex align-items-center justify-content-center mb-3">
              <IconButton
                onClick={this.handleToggleMute}
                className="enCallControl mr-3"
              >
                <Image
                  src={
                    this.state.muted
                      ? require("../../assets/images/UserManagement/mute.svg")
                      : require("../../assets/images/UserManagement/mic.svg")
                  }
                  alt="mic"
                  title="mic"
                  className={this.state.muted ? "p-2" : ""}
                  style={{
                    width: "58px",
                    backgroundColor: this.state.muted ? "#fff" : "",
                    borderRadius: this.state.muted ? "50px" : "",
                  }}
                />
              </IconButton>
              <IconButton
                onClick={this.onCallDisconnect}
                className="enCallControl"
              >
                <Image
                  src={require("../../assets/images/UserManagement/off.svg")}
                  alt="View"
                  title="View"
                  style={{ width: "58px" }}
                />
              </IconButton>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

TwilioCalling.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors && state.errors.errors,
});

export default connect(mapStateToProps, {
  get_twilio_calling,
})(withRouter(TwilioCalling));

// import React, { useState } from "react";
// import { Button, Modal, Image } from "react-bootstrap";
// import { IconButton } from "@material-ui/core";

// export const TwilioCalling = () => {
//   const [show, setShow] = useState(false);
//   const handleClose = () => setShow(false);
//   const handleShow = () => setShow(true);

//   return (
//     <React.Fragment>
//       <Button variant="link" className="enIconBtn mr-3" onClick={handleShow}>
//         <Image
//           src={require("../../../../assets/images/UserManagement/phone.svg")}
//           alt="Call"
//           title="Call"
//           fluid
//         />
//       </Button>
//       <Modal
//         show={show}
//         onHide={handleClose}
//         centered
//         size="sm"
//         className="enCallModal"
//       >
//         <Modal.Header className="pb-0 border-0" closeButton></Modal.Header>
//         <Modal.Body className="text-center pt-0 mt-3">
//           <div className="f11-700 mb-4">Sophie French</div>
//           <div className="enCallUserPic d-table mx-auto">
//             <Image
//               src={require("../../../../assets/images/UserManagement/user.png")}
//               alt="View"
//               title="View"
//               fluid
//             />
//           </div>
//           <div className="f20-400 mb-4">04:56</div>
//           <div className="d-flex align-items-center justify-content-center mb-3">
//             <IconButton className="enCallControl mr-3">
//               <Image
//                 src={require("../../../../assets/images/UserManagement/mic.svg")}
//                 alt="View"
//                 title="View"
//               />
//             </IconButton>
//             <IconButton className="enCallControl">
//               <Image
//                 src={require("../../../../assets/images/UserManagement/speeker.svg")}
//                 alt="View"
//                 title="View"
//               />
//             </IconButton>
//           </div>
//           <IconButton
//             onClick={handleClose}
//             className="enCallOff d-table m-auto"
//           >
//             <Image
//               src={require("../../../../assets/images/UserManagement/off.svg")}
//               alt="View"
//               title="View"
//             />
//           </IconButton>
//         </Modal.Body>
//       </Modal>
//     </React.Fragment>
//   );
// };
